import {
  addComment,
  ConversationModel,
  create,
  deleteComment,
  resolveComment,
  reopenComment,
  ResourceProvider,
  updateComment,
} from 'src/components/conversation';

import { ProviderConfig } from './types';
import { toFabricUser } from './utils';

export class ConversationProvider implements ResourceProvider {
  // @ts-ignore
  config: ProviderConfig;

  constructor(config: ProviderConfig) {
    this.config = config;
  }

  static getProvider(config: ProviderConfig): ConversationProvider {
    return new ConversationProvider({
      ...config,
      // @ts-ignore
      user: config.user ? toFabricUser(config.user) : null,
    });
  }

  updateConfig(updatedConfig: Partial<ProviderConfig>): void {
    this.config = { ...this.config, ...updatedConfig };
  }

  // @ts-ignore
  addComment = addComment;
  // @ts-ignore
  create = create;
  deleteComment = deleteComment;
  // @ts-ignore
  updateComment = updateComment;

  resolveComment = resolveComment;
  reopenComment = reopenComment;

  getConversation(
    conversations: ConversationModel[],
    conversationId: string
  ): ConversationModel {
    const [conversation] = conversations.filter(
      c => c.conversationId === conversationId
    );
    return conversation;
  }
}
